import React, { useEffect } from 'react';
import { Provider } from 'react-redux';
import { BrowserRouter as Router } from 'react-router-dom';
import store, { persistor } from '@store/index';
import AppRouter from '@layouts/AppRouter';
import { PersistGate } from 'redux-persist/integration/react';
import { ThemeProvider } from '@mui/material/styles';
import theme from '@utils/Theme';
import { APIProvider } from '@vis.gl/react-google-maps';
import IOSConfirmDialog from '@components/Utilities/IOSConfirmDialog';

function App() {
    useEffect(() => {
        if (process.env.NODE_ENV && process.env.NODE_ENV === 'production') {
            const cssRed = 'color: red; text-shadow: 0px 0px 0px rgba(0,0,0,0); font-size: 30px;';
            const cssBlack = 'font-size: 15px;';
            const cssKrispis =
                'color: red; text-shadow: 2px 2px 6px rgba(255,0,0,0.89); font-size: 25px; font-weight: bold';
            console.log('%c¡Detente!', cssRed);
            console.log(
                '%c¡Esta función del navegador está pensada para desarrolladores. Si alguien sin autorización entra al modo desarrollador para intentar vulnerar el sistema, será registrado y sancionado !',
                cssBlack
            );
            console.log('%cKRISPIS System 2026', cssKrispis);
        }
    }, []);

    return (
        <Provider store={store}>
            <PersistGate loading={null} persistor={persistor}>
                <Router>
                    <ThemeProvider theme={theme}>
                        <APIProvider apiKey={process.env.REACT_APP_API_KEY || ''}>
                            <AppRouter />
                        </APIProvider>
                        <IOSConfirmDialog />
                    </ThemeProvider>
                </Router>
            </PersistGate>
        </Provider>
    );
}

export default App;
